import React from "react";

import { toast } from "react-toastify";

export const defaultToastConfig = {
  autoClose: 4000,
  closeOnClick: false,
  draggable: false,
  icon: false, // ms
  position: toast.POSITION.BOTTOM_CENTER,
  theme: "dark",
  toastTimeout: 300 // ms
};

export const toastNotify = (message, extraContent = false) => {
  toast.dismiss();
  setTimeout(
    () =>
      toast(
        <div className="Toastify__toast-contents">
          <span className="Toastify__message-content">{message}</span>
          {!!extraContent && (
            <span className="Toastify__extra-content">{extraContent}</span>
          )}
        </div>,
        defaultToastConfig
      ),
    defaultToastConfig.toastTimeout
  );
};
